import { APITypes, OrganizationTypes } from '../../../../../../../primary-record-types';
import { clientRecordStatus } from '../../../../../../../utils/sharedMessages';
import { SelectedCategories } from '../../../../../../v2BaseComponents/RichTable/types';

export type UseSelectedCategoriesArgs = {
    selectedClients: APITypes.organizationService.ListOrganizationClientRecordsResponse['items'];
};

export type UseSelectedCategoriesReturnValue = {
    selectedCategories: SelectedCategories;
};

const statuses: OrganizationTypes.OrganizationClientRecord['status'][] = [
    'not-invited',
    'archived',
    'invited',
    'invitation-rejected',
    'active',
    'inactive',
];

const getCategories = (
    selectedClients: APITypes.organizationService.ListOrganizationClientRecordsResponse['items'],
): SelectedCategories => {
    return statuses.map((status) => ({
        label: clientRecordStatus(status),
        count: selectedClients.filter((client) => client.status === status).length,
    }));
};

export const useSelectedCategories = ({ selectedClients }: UseSelectedCategoriesArgs) => {
    return {
        selectedCategories: getCategories(selectedClients),
    };
};
